<h2 mat-dialog-title>Re-Enroll Students into {{selectedYear.Description}}</h2>
<mat-dialog-content style="padding-top: 0px !important;">
  <div>
    <form id="addEmergencyContactForm">
        <mat-table #table [dataSource]="angularMatDataStudents" style="display: grid; padding-top: 0px!important;" >
            <ng-container matColumnDef='Checked'>
              <mat-header-cell *matHeaderCellDef style="min-width: 60px; max-width: 60px;" translate>
                <tyl-checkbox id="chkAll" type="checkbox" (change)="selectAll()"
                  [(checked)]="allStudentsSelected"></tyl-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let ss" style="min-width: 60px; max-width: 60px;">
                <span>
                  <tyl-checkbox type="checkbox" (change)="studentSelect()"
                      [(checked)]="ss.Selected"></tyl-checkbox>
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef='Student'>
              <mat-header-cell *matHeaderCellDef translate>Student</mat-header-cell>
              <mat-cell *matCellDef="let ss">
                <span>{{ss.StudentName}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef='GradeLevel'>
              <mat-header-cell *matHeaderCellDef style="max-width: 180px; min-width: 180px;" translate>Grade Level into which Student will be Enrolling</mat-header-cell>
              <mat-cell *matCellDef="let ss" style="max-width: 180px; min-width: 180px;">
                <tyl-form-field style="width: 150px;">
                  <mat-select [(ngModel)]="ss.EnrollmentGradeLevel" id="selectedGradeLevel{{ss.StudentId}}" name="EntryGradeLevel{{ss.StudentId}}" [falseyRequired]="ss.Selected">
                    <mat-option *ngFor="let gl of gradeLevels;" value="{{gl.Id}}">
                      <span>{{gl.Code}}</span>
                    </mat-option>
                  </mat-select>
                </tyl-form-field>
              </mat-cell>
            </ng-container>
            <!-- <ng-container matColumnDef='Grade'>
              <mat-header-cell *matHeaderCellDef style="max-width: 70px; min-width: 70px;" translate>Grade</mat-header-cell>
              <mat-cell *matCellDef="let ss" style="max-width: 70px; min-width: 70px;">
                <span>{{ss.GradeLevel}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef='School'>
              <mat-header-cell *matHeaderCellDef translate>School</mat-header-cell>
              <mat-cell *matCellDef="let ss">
                <span>{{ss.SchoolDescription}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef='Withdrawn'>
              <mat-header-cell *matHeaderCellDef translate>Withdrawn</mat-header-cell>
              <mat-cell *matCellDef="let ss">
                <span>{{ss.WithdrawalDate | date: 'MM/dd/yyyy'}}</span>
              </mat-cell>
            </ng-container> -->
            <ng-container matColumnDef="Previous Enrollment">
              <mat-header-cell *matHeaderCellDef style="padding-top:10px!important; min-width: 350px; max-width: 350px;">
                  <table style="width: 100%;">
                      <tr>
                          <td colspan="3" style="text-align:center; height: 30px; background-color: lightgray;" translate>Previous Enrollment</td>
                      </tr>
                      <tr>
                          <td style="text-align:left; width: 15%;" translate>Grade</td>
                          <td style="text-align:left;  width: 55%; padding-right: 5px; padding-left: 2px;" translate>School</td>
                          <td style="text-align:left; width: 30%;" translate>Withdrawn</td>
                      </tr>
                  </table>
              </mat-header-cell>
              <mat-cell *matCellDef="let ss" style="min-width: 350px; max-width: 350px;">
                  <table style="width: 100%;">
                      <tr>
                          <td style="text-align:left;  width: 15%;">
                              {{ss.GradeLevel}}</td>
                          <td style="text-align:left;  width: 55%;  padding-right: 5px; padding-left: 2px;">
                              {{ss.SchoolDescription}}</td>
                              <td style="text-align:left; width: 30%;">
                                <span *ngIf="ss.WithdrawalDate != '0001-01-01T00:00:00'">{{ss.WithdrawalDate | date: 'MM/dd/yy'}}</span>
                              <span *ngIf="ss.WithdrawalDate == '0001-01-01T00:00:00'"></span></td>
                      </tr>
                  </table>
              </mat-cell>
          </ng-container>
            <mat-header-row *matHeaderRowDef="columnToDisplay" style="position: sticky;"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" id="row{{i}}"></mat-row>
          </mat-table>
    </form>
  </div>
  
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex-footer-right">
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button style="float:right;" image="next arrow.png" label="Continue" (clickEvent)="modalInstanceContinueClick(); validationTrigger.click();"></tyl-button>

    <tyl-button style="float:right;" image="Cancel.png" (click)="modalInstanceCancelClick()" label="Cancel"></tyl-button>
  </div>
</mat-dialog-actions>
<input type="submit" form="addEmergencyContactForm" style="display: none" #validationTrigger>